import React from 'react';

type PageLayoutProps = {
  children: React.ReactNode;
  title?: string;
  buttonRight?: React.ReactNode;
};

export const PageLayout = ({ title, children, buttonRight }: PageLayoutProps) => {
  return (
    <div className="flex flex-col gap-3">
      <div className="flex items-center justify-between">
        {title && <h1 className="text-3xl font-bold">{title}</h1>}
        {buttonRight}
      </div>
      <div>{children}</div>
    </div>
  );
};
